import { render, staticRenderFns } from "./bulk-list.vue?vue&type=template&id=51acd75a&"
import script from "./bulk-list.vue?vue&type=script&lang=js&"
export * from "./bulk-list.vue?vue&type=script&lang=js&"
import style0 from "./bulk-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports